import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import MyMixrs from 'srcReact/MyHomePage/components/MyMixrs'
import MyGroups from 'srcReact/MyHomePage/components/MyGroups'
import WelcomeBanner from 'srcReact/components/common2/WelcomeBanner'
import styles from './styles.module.scss'
import { useSelector, useDispatch } from 'react-redux'
import { isHDPlusScreen } from 'srcReact/helpers/utils'
import TutorialV2 from 'srcReact/components/popinsContent/TutorialV2'
import { urlSearchParams } from 'srcReact/helpers/utils'
import Spinner from 'srcReact/components/common2/Spinner'
import { checkNested } from 'srcReact/helpers/validator'
import { myhomeActions } from 'srcReact/MyHomePage'
import { commonActions } from 'srcReact/components'
import Tabs from 'srcReact/components/common2/Tabs'
import ReviewButtons from './components/ReviewButtons'

const MyHomePageContainer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isHDPlus, setIsHDPlus] = useState(isHDPlusScreen())
  const [isTutorialModalOpen, setIsTutorialModalOpen] = useState(false)
  // const [apiTriggered, setApiTriggered] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [orderBy, setOrderBy] = useState('allmixrs')
  const {
    common: { isNative, isMobile, userLocation },
    organization: { current_organization, header },
    myhome: { all }
  } = useSelector((state) => state)

  useEffect(() => {
    if (checkNested(current_organization, 'info', 'id')) {
      dispatch(commonActions.addUserPageView(appConstantSettings.MYHOME_PAGE, current_organization.info.id))
    }

    window.scrollTo(0, 0)
    window.addEventListener('resize', handleWindowSizeChange)

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])
  useEffect(() => {
    // if (!apiTriggered) {
    // nativeapp
    if (isNative) {
      dispatch(
        myhomeActions.getMyHomeAll(
          urlSearchParams('id_workplace').toString(),
          urlSearchParams('lat'),
          urlSearchParams('lon')
        )
      )
      // setApiTriggered(true)
      return
    }

    if (checkNested(current_organization, 'info', 'my_access', 'role_as_workplace_member')) {
      const workplaceIds = current_organization.info.my_access.role_as_workplace_member.workplace_list
      if (workplaceIds && workplaceIds.length >= 1 && userLocation) {
        dispatch(myhomeActions.getMyHomeAll(workplaceIds.toString(), userLocation.latitude, userLocation.longitude))
        // setApiTriggered(true)
      }
    }
    // }
  }, [current_organization?.info?.id])
  useEffect(() => {
    if (header?.popup?.has_been_displayed !== undefined && header?.popup?.has_been_displayed !== 1) {
      showTutorialModal()
      dispatch(commonActions.setPopupCookie('v2_migration'))
    }
  }, [header])

  const showTutorialModal = () => {
    setIsTutorialModalOpen(true)
  }
  const hideTutorialModal = () => {
    setIsTutorialModalOpen(false)
  }
  const handleWindowSizeChange = () => {
    setIsHDPlus(isHDPlusScreen())
  }
  const handleMixrScopeChange = (tabNum, tabName) => {
    setActiveTab(tabNum)
    setOrderBy(tabName)
  }

  return (
    <PageContainer pageTitle={t('myhome.title')} withFooter={false} withSidebar={true}>
      <WelcomeBanner firstname={all.authUser.firstname} isNative={isNative} />
      {all.loading && !all.loaded && (
        <div className={`${styles.myHomePageWrapper} ${isNative && styles.nativeMyHomePageWrapper}`}>
          <Spinner />
        </div>
      )}
      {all.loaded && (
        <div className={`${styles.myHomePageWrapper} ${isNative && styles.nativeMyHomePageWrapper}`}>
          <div className={styles.reviewButtons}>
            <ReviewButtons
              reviewGroups={all.moderation_info.groups}
              reviewWorkplaces={all.workplace_invitations}
              isNative={isNative}
              isMobile={isMobile}
            />
          </div>
          {appConstantSettings.ENABLE_MYHOME_CAROUSEL_TAB ? (
            <Tabs
              initialActive={activeTab}
              className={styles.tabs}
              contentClassName={styles.contentTabs}
              type='boxed'
              aligned={isMobile ? 'centered' : 'spacebetween'}>
              <div label={t('global.allmixrs')} onClick={() => handleMixrScopeChange(0, 'allmixrs')}>
                <MyMixrs isMobile={isMobile} orderBy={orderBy} />
              </div>
              <div label={t('global.mymixrs')} onClick={() => handleMixrScopeChange(1, 'mymixrs')}>
                <MyMixrs isMobile={isMobile} orderBy={orderBy} />
              </div>
              <div label={t('global.pending')} onClick={() => handleMixrScopeChange(2, 'pending')}>
                <MyMixrs isMobile={isMobile} orderBy={orderBy} />
              </div>
            </Tabs>
          ) : (
            <div className={styles.contentTabs}>
              <MyMixrs isMobile={isMobile} orderBy={orderBy} />
            </div>
          )}
          <MyGroups isMobile={isMobile} isHDPlus={isHDPlus} />
        </div>
      )}
      {isTutorialModalOpen && <TutorialV2 closeModal={hideTutorialModal} onboardingType='first_time' />}
    </PageContainer>
  )
}

export { MyHomePageContainer }
